import { useCallback, useMemo } from 'react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { encodeSearchParams } from 'lib/search/searchUtils'
import { ANYWHERE_SEARCH_ITEM } from 'constants/search'
import config from 'constants/config'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from '../constants/luxPlusMonthTakeoverConstants'

function LuxPlusMonthTakeoverBestHotelOffersCarousel() {
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  const filters = useMemo<App.OfferListFilters>(() => ({
    offerTypes: ['tactical_ao_hotel'],
    limit: 20,
    campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  }), [])

  const searchQuery = useMemo(() => encodeSearchParams({
    searchItem: ANYWHERE_SEARCH_ITEM,
    rooms: [config.search.defaultOccupants],
    filters,
  }), [filters])

  return (
    <OfferCardCarouselSection
      title={<FormattedMessage
        id="kVZhMKvgQhrg1S7kIDk1"
        defaultMessage="<i>Bigger savings</i> on great hotel offers"
        description="Section title for the LuxPlus+ Month campaign landing page hotel offers carousel, with 'Bigger savings' shown in italics"
        values={{ i: renderItalic }}
      />}
      filters={filters}
      allLink={`/search?${searchQuery.toString()}`}
      hideWhenEmpty
      tileStyle="card-default"
      tileSize="medium"
    />
  )
}

export default LuxPlusMonthTakeoverBestHotelOffersCarousel
